import { EventEmitter, Input, Output, Directive } from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {SelectItem} from 'primeng/api';

@Directive()
export abstract class AbstractSelectComponent<T> {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string;

  @Input()
  placeholder: string ;

  @Input()
  controlName: string;

  @Input()
  showLabel: boolean = true;

  @Input()
  showPlaceholder: boolean = true;

  @Output()
  onSelect: EventEmitter<T> = new EventEmitter();

  items: SelectItem[] = [];

  protected constructor(private defaultLabel: string,
                        private defaultPlaceholder: string,
                        private defaultControlName: string) {
    this.label = this.defaultLabel;
    this.placeholder = this.defaultPlaceholder;
    this.controlName = this.defaultControlName;
  }

  protected abstract init();

}
